export default __webpack_public_path__ + "static/media/765.162f87eb.png";